import { post } from "./utils";

export const user = {
  login: (parameters) => {
    return post("/api/basis/login/", parameters);
  },
  updateProfile: (parameters, token) => {
    return post("/api/basis/update_profile/", parameters, token);
  },
  sendCode: (parameters, token) => {
    return post("/api/basis/send_code/", parameters, token);
  },
  verifyCode: (parameters, token) => {
    return post("/api/basis/verify_code/", parameters, token);
  },
};
